<template>
  <p class="text-gray-500 text-sm/6">
    <slot />
  </p>
</template>
